import React, { useState, useEffect, useContext } from "react";

import { Dropdown } from "antd";

import { FiltersContext } from "../../../../context/Filters";

import { WhiteSourceIcon, BlackSourceIcon } from "../../../Reusable/Icons";
import Menu from "./Menu";

import styles from "../filter.module.scss";

const Source = ({ source }) => {
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState("Source");

  const { filters, setFilter, removeFilter } = useContext(FiltersContext);

  useEffect(() => {
    const source = filters.source;
    if (!!source?.length) {
      setText(`Filtered by ${source.length}`);
    } else {
      setText("Source");
    }
  }, [filters]);
  return (
    <Dropdown
      overlay={
        <Menu
          closeDropdown={setVisible}
          setFilter={setFilter}
          removeFilter={removeFilter}
          defaultValue={filters.source}
          options={source?.values?.split(",")}
        />
      }
      getPopupContainer={(trigger) => {
        return trigger.parentNode;
      }}
      trigger="click"
      visible={visible}
      placement="bottomCenter"
      overlayStyle={{ height: "100%" }}
      onVisibleChange={(v) => setVisible(v)}
    >
      <div
        className={`${styles.filterContainer} ${
          !!filters.source?.length ? styles.active : ""
        }`}
      >
        {!!filters.source?.length ? (
          <WhiteSourceIcon fill="white" />
        ) : (
          <BlackSourceIcon fill="black" />
        )}
        {text}
      </div>
    </Dropdown>
  );
};

export default Source;
